import { render } from "./BackTopBar.vue?vue&type=template&id=306455fa&scoped=true"
import script from "./BackTopBar.vue?vue&type=script&lang=js"
export * from "./BackTopBar.vue?vue&type=script&lang=js"

import "./BackTopBar.vue?vue&type=style&index=0&id=306455fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306455fa"]])

export default __exports__